module.exports = __webpack_public_path__ + "media/images/emblems/Berguen_(Kreis)_wappen-9293f3eeee7cfaded3bec967b46c8cae.svg";